import React, { useState } from 'react'
/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react"
import TextField from '@mui/material/TextField';
import TeacherPage from './TeacherPage';
import { Helmet } from 'react-helmet-async';

const TeacherPageCertification = () => {
  const [isTeacher, setIsTeacher] = useState(false);
  const [unSuccessful, setUnSuccessful] = useState(false);

  const inputPass = (e) => {
    if (e.value === process.env.REACT_APP_TEACHERS_PASS) {
      setIsTeacher(true);
    } else {
      setUnSuccessful(true);
    }
  }

  const certificationStyle = css`
    width: 100vw;
    padding: 0;
    margin: 0;
    .window {
      position: relative;
      h3 {
        position: absolute;
        top: 80px;
        left: 50%;
        transform: translateX(-50%);
      }
      p {
        position: absolute;
        top: 300px;
        left: 50%;
        transform: translateX(-50%);
        white-space: nowrap;
        font-size: 0.7em;
      }
      color: #555;

      border-radius: 15px;
      margin: 150px auto;
      text-align: center;
      width: 500px;
      height: 500px;
      background-color: #ffffff;
      box-shadow:
        0 1.9px 2.5px rgba(0, 0, 0, 0.057),
        0 5px 6.1px rgba(0, 0, 0, 0.076),
        0 10.1px 11.4px rgba(0, 0, 0, 0.086),
        0 19.2px 19.8px rgba(0, 0, 0, 0.092),
        0 38.4px 34.8px rgba(0, 0, 0, 0.1),
        0 101px 74px rgba(0, 0, 0, 0.13);
    }
  `;

  return (
    <>
      <Helmet>
        <title>🐝｜先生用ページ</title>
      </Helmet>

      {
        isTeacher ? (
          <div>
            <TeacherPage />
          </div>
        )
          :
          (
            <div css={certificationStyle}>
              <div className='window'>
                <h3>認証</h3>
                <p>先生用パスワードを入力してください</p>
                {
                  unSuccessful ? (
                    <TextField
                      error
                      id="outlined-error-helper-text"
                      label="Error"
                      helperText="Incorrect entry."
                      sx={{ marginTop: '250px' }}
                      onKeyDown={(e) => {
                        if (e.key = 'Enter') {
                          inputPass(e.target)
                        }
                      }}
                    />
                  ) : (
                    <TextField
                      id="filled-basic" label="パスワード" variant="filled"
                      sx={{ marginTop: '250px' }}
                      onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                          // エンターキー押下時の処理
                          inputPass(e.target);
                        }
                      }}
                    />
                  )
                }

              </div>
            </div>
          )
      }
      <div>

      </div>
    </>
  )
}

export default TeacherPageCertification
